/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IAppointments } from 'app/shared/model/appointments.model';
import { IReminderOptions } from 'app/shared/model/reminder-options.model';
import { IDuration } from 'app/shared/model/duration.model';

export interface IReminders {
  id?: string;
  reminderFor?: string;
  reminderNo?: string;
  reminderTime?: string;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  active?: boolean;
  cursor?: number;
  appointment?: IAppointments;
  reminderOptionCode?: IReminderOptions;
  durationCode?: IDuration;
}

export const defaultValue: Readonly<IReminders> = {
  active: false,
};
